import {register} from '@shopify/theme-sections';
import Flickity from 'flickity-as-nav-for';

import 'flickity-imagesloaded';

import '../img-comparison-slider';

const selectors = {
  mainSlider: '.product-results__before-after-slider',
  thumbnailSlider: '.product-results__thumbnail-slider',
};

export default register('product-results', {
  onLoad() {
    const beforeAfterSlider = this.container.querySelector(selectors.mainSlider);
    const thumbnailSlider = this.container.querySelector(selectors.thumbnailSlider);
    const previousButton = this.container.querySelector('.btn--control-prev');
    const nextButton = this.container.querySelector('.btn--control-next');

    if (!beforeAfterSlider || !thumbnailSlider) return;

    this.mainSlider = new Flickity(beforeAfterSlider, {
      draggable: false,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
    });

    const thumbSlider = new Flickity(thumbnailSlider, {
      draggable: false,
      asNavFor: beforeAfterSlider,
      prevNextButtons: false,
      pageDots: false,
      arrows: true,
      groupCells: false,
      contain: true,
      cellAlign: 'left',
      imagesLoaded: true,
      arrowShape: 'M 0,50 L 60,00 L 50,30 L 80,30 L 80,70 L 50,70 L 60,100 Z',
      wrapAround: true,
      on: {
        ready() {
          if (!previousButton || !nextButton) return;
          previousButton.addEventListener('click', function () {
            thumbSlider.previous();
          });
          nextButton.addEventListener('click', function () {
            thumbSlider.next();
          });
        },
      },
    });
  },
});
